import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import MainForm from "./EmploymentForm/MainForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployment,
  addEmployment,
  saveEmploymentAnswer,
  deleteEmploymentAnswer,
  saveEmployment,
} from "../Actions/employmentActions";
import { getData } from "../Actions/landingAction";
import { useParams } from "react-router-dom";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import QuestionForm from "../components/EmploymentForm/QuestionForm";
import { fresherOptions, CurrentlyEmployedOptions } from "./EmploymentForm/empConstants";
import Loader from "./Common/loader";
import GetMasterData from "../Helper/masterData";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer.js";
import _ from "lodash";
import StepCount from "./Common/StepCount";
import EmploymentGaps from "./EmploymentGaps";
import axios from "axios";
import { FOLDERPATH } from "../Constants/config";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const CandidateEmployment = () => {
  let { activeTab, reference } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [employment, setEmployment] = useState({});
  const [unsavedEmpData, setUnsavedEmpData] = useState({});
  const [unsavedErrorData, setUnsavedErrorData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCurrentEmploymentQuestion, setShowCurrentEmploymentQuestion] = useState(null);
  const [showQuestion, setShowQuestion] = useState(null);
  const [currentEmploymentAnswered, setCurrentEmploymentAnswered] = useState(false);
  const [answer1, setAnswer1] = useState("");
  const [answerError1, setAnswerError1] = useState(false);
  const [answer, setAnswer] = useState("");
  const [answerError, setAnswerError] = useState(false);
  const [redirectToTabOne, setRedirectToTabOne] = useState(true);
  const [states, setStates] = useState([]);
  const [currencies, setCurrencies] = useState({});
  const [questionData, setQuestionData] = useState({});
  const [questionData1, setQuestionData1] = useState({});
  const [showAddPopup, setShowAddPopup] = useState(false);
  const { stateOptionspv, currencyOptions, countryCodeOptions } =
    GetMasterData();
  const [caseStatusCheckDetails, setCaseStatusCheck] = useState({});
  const [checkStatus, setCheckStatus]=useState();
  const [hasGap, setHasGap] = useState(false);
  const [gapData, setGapData] = useState({});
  const [showAlertPopUp, setShowAlertPopUp] = useState(false);
  const [previousEmpoymentCountPopUp, setPreviousEmploymentCountPopUp] =
    useState(false);
  const [role,setRole]=useState();

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let obj2 = {};
    for (var j in currencyOptions) {
      obj2[currencyOptions[j].value] = currencyOptions[j].label.currency;
    }
    setStates(stateOptionspv);
    setCurrencies(obj2);
  }, [stateOptionspv, currencyOptions]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getEmployment());
    };

    fetchData();
  }, []);

  const storeData = useSelector((state) => state.employment);
  const storeData2 = useSelector((state) => state.questionData);
  const employmentAddStore = useSelector((state) => state.employmentAdd);
  const { employmentData, loading: getEmploymentDataLoading } = storeData;
  const { employmentQuestionData, loading: employmentQuestionDataLoading } =
    storeData2;

  useEffect(() => {
    if (
      employmentAddStore?.employmentAddData &&
      employmentAddStore?.employmentAddData?.message?.toUpperCase() ===
        "MAXIMUM EMPLOYMENTS ALREADY ADDED"
    ) {
      setShowAlertPopUp(true);
    } else {
      setShowAlertPopUp(false);
    }
  }, [employmentAddStore]);

  useEffect(() => {
    employmentData?.data?.data?.checksDetails?.map((tab) =>
      console.log("tab...removed 1", tab?.case_check_id)
    );
    if (employmentData?.data?.data?.checksDetails?.length) {
      employmentData.data.data.checksDetails.map((detail) => {
        setCaseStatusCheck((prevState) => ({
          ...prevState,
          [`${detail?.case_check_id}`]: detail?.check_status,
        }));
      });
    }
    if (employmentData?.data?.data?.candidates?.is_currently_employed) {
      setCurrentEmploymentAnswered(true)
      if (employmentData?.data?.data?.candidates?.is_currently_employed == 2) {
        setAnswer1("No");
      }
      if (employmentData?.data?.data?.candidates?.is_currently_employed == 1) {
        setAnswer1("Yes");
      }
    }
    if (employmentData?.data?.data?.candidates?.is_fresher) {
      if (employmentData?.data?.data?.candidates?.is_fresher == 2) {
        setAnswer("No");
      }
      if (employmentData?.data?.data?.candidates?.is_fresher == 1) {
        setAnswer("Yes");
      }
    }
  }, [employmentData]);

  useEffect(() => {
    if (
      employmentData &&
      employmentData.data &&
      typeof employmentData.data !== "undefined" &&
      employmentData.data !== null
    ) {
      if (Object.keys(unsavedEmpData).length == 0) {
        setEmployment(employmentData.data.data);
        if (employmentData?.data?.data?.checksDetails?.length) {
          employmentData.data.data.checksDetails.map((detail) => {
            setCaseStatusCheck((prevState) => ({
              ...prevState,
              [`${detail?.case_check_id}`]: detail?.check_status,
            }));
            if(detail?.check_id ==41){
              setCheckStatus(detail?.check_status)
            }
          });
        }
      } else {
        const updatedData = employmentData.data.data;
        let newData = _.cloneDeep(unsavedEmpData);
        let checksDetailsMain = _.cloneDeep(newData.checksDetails);
        let updatedChecksDetails = _.cloneDeep(updatedData.checksDetails);
        const checksDetailsMainLength = checksDetailsMain.length;
        const updatedChecksDetailsLength = updatedChecksDetails.length;
        if (checksDetailsMainLength == updatedChecksDetailsLength) {
          for (var i in checksDetailsMain) {
            checksDetailsMain[i]["uploaded_documents"] = updatedChecksDetails[i]
              .uploaded_documents
              ? updatedChecksDetails[i].uploaded_documents
              : [];
            checksDetailsMain[i]["uploaded_instant_documents"] =
              updatedChecksDetails[i].uploaded_instant_documents
                ? updatedChecksDetails[i].uploaded_instant_documents
                : [];
          }
        } else if (updatedChecksDetailsLength > checksDetailsMainLength) {
          checksDetailsMain.push(
            updatedChecksDetails[updatedChecksDetailsLength - 1]
          );
        } else {
          let checkToBeRemovedIndex = null;
          for (let i = 0; i < checksDetailsMain.length; i++) {
            let isCheckPresent = false;
            for (let j = 0; j < updatedChecksDetails.length; j++) {
              if (
                checksDetailsMain[i].case_check_id ==
                updatedChecksDetails[j].case_check_id
              ) {
                isCheckPresent = true;
                break;
              }
            }
            if (!isCheckPresent) {
              checkToBeRemovedIndex = i;
            }
          }
          if (checkToBeRemovedIndex) {
            let newChecksDetails = [];
            for (let i = 0; i < checksDetailsMain.length; i++) {
              if (i != checkToBeRemovedIndex) {
                newChecksDetails.push(checksDetailsMain[i]);
              }
            }
            checksDetailsMain = _.cloneDeep(newChecksDetails);
          }
        }

        newData.checksDetails = _.cloneDeep(checksDetailsMain);
        if (updatedData?.checksDetails?.length) {
          updatedData.checksDetails.map((detail) => {
            setCaseStatusCheck((prevState) => ({
              ...prevState,
              [`${detail?.case_check_id}`]: detail?.check_status,
            }));
          });
        }
        setEmployment(newData);
      }
      const showCurrentEmploymentQuestionCondition=employmentData?.data?.data?.is_current_emp_question_enabled === "1"?true:false
      setShowCurrentEmploymentQuestion(showCurrentEmploymentQuestionCondition)
      if(showCurrentEmploymentQuestionCondition==true){
        let queObj= {};
        queObj["question"] = "Are you currently employed ?";
        queObj["options"] = CurrentlyEmployedOptions;
        queObj["questionKey"] = "isCurrentlyEmployed";

        setQuestionData1(queObj);
      }
      const showQuestionCondition =
        (employmentData.data.data.fresher_enabled === "1" ||
        employmentData.data.data.employmentpopupshow === "1") 
          ? true
          : false;
      const fresherValue = employmentData.data.data.candidates.is_fresher;
      const numberOfEmploymentChecks =
        employmentData.data.data.candidates.employment_check_count;
      let showQuestionPage = null;
      const bothVal1 =
        employmentData.data.data.fresher_enabled === "1" &&
        employmentData.data.data.employmentpopupshow === "1"
          ? true
          : false;
      if ((showQuestionCondition && fresherValue) || bothVal1) {
        let quesObj = {};
        let question =
          employmentData.data.data.employmentpopupshow === "1"
            ? employmentData.data.data.employement_question
            : "Are you a fresher?";
        if (question == "" || question == null) {
          question = "Are you a fresher?";
        }
        quesObj["question"] = question;
        let opts =
          employmentData.data.data.employmentpopupshow === "1"
            ? employmentData.data.data.employment_options
            : fresherOptions;
        if (!opts || opts.length == 0) {
          opts = fresherOptions;
        }
        quesObj["options"] = opts;
        quesObj["questionKey"] =
          employmentData.data.data.employmentpopupshow === "1"
            ? "empCntr"
            : "fresherValue";
        if (employmentData.data.data.employement_question == "") {
          quesObj["questionKey"] = "fresherValue";
        }
        setQuestionData(quesObj);
        showQuestionPage = true;
      }
      if (showQuestionCondition == true && fresherValue == 2) {
        showQuestionPage = true;
        setAnswer("No");
      }
      if (showQuestionCondition == true && fresherValue == 1) {
        showQuestionPage = true;
        setAnswer("Yes");
      }
      if (numberOfEmploymentChecks != null && numberOfEmploymentChecks > 1) {
        showQuestionPage = false;
        setAnswer(numberOfEmploymentChecks);
      }
      setShowQuestion(showQuestionPage);
    }
  }, [employmentData, storeData]);

  useEffect(() => {
    if (employmentQuestionData.msg && employmentQuestionData.msg === "Done") {
      setShowQuestion(false);
    }
    if (employmentQuestionData.data) {
      const groupId = employmentQuestionData.data.group.group_id;
      const userLocalData = JSON.parse(
        localStorage.getItem("userVerificationCandidate")
      );
      if (groupId == "profile_preview") {
        navigate(
          `/case-initiation/profile-preview/${userLocalData.reference_number}`
        );
      } else {
        navigate(
          `/case-initiation/check-detail/${userLocalData.reference_number}/${groupId}`
        );
      }

      dispatch(deleteEmploymentAnswer());
    }
  }, [employmentQuestionData, storeData2]);
  useEffect(() => {
    if (
      typeof getEmploymentDataLoading !== "undefined" &&
      getEmploymentDataLoading !== null
    ) {
      if (getEmploymentDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [employmentData]);
  const reRenderAgain = (data, redirect) => {
    setUnsavedEmpData(data);
    setRedirectToTabOne(redirect);
    dispatch(getEmployment());
  };

  const refreshData = async (redirect, errorIndex) => {
    // setUnsavedEmpData(data); //Needs to make it generaalzuber
    setRedirectToTabOne(redirect);
    let errData = _.cloneDeep(unsavedErrorData);
    let newErr = [];
    for (var i in errData) {
      if (i != errorIndex) {
        newErr.push(errData[i]);
      }
    }
    setUnsavedErrorData(newErr);
    await dispatch(getEmployment());
    await dispatch(getData());
  };

  const handleQuestionChange = (e) => {
    if (e[0].name == "empCntr") {
      if (e[0].value !== "") {
        setAnswerError(false);
        setAnswer(e[0].value);
      }
    } else {
      if (e[0].value !== "") {
        setAnswerError(false);
        if (e[0]?.value == "1") {
          setAnswer("Yes");
        }
        if (e[0]?.value == "2") {
          setAnswer("No");
        }
      }
    }
  };

  const handleCurrentEmploymentQuestionChange = (e) => {
    
      if (e[0].value !== "") {
        setAnswerError1(false);
        if (e[0]?.value == "1") {
          setAnswer1("Yes");
        }
        if (e[0]?.value == "2") {
          setAnswer1("No");
        }
      }
    
  };


  const handleSave1 = async (key) => {
    if (answer1 === "") {
      setAnswerError1(true);
      return;
    } else {
      let answerVal = "";
      
        answerVal = answer1 === "Yes" ? 1 : answer1 === "No" ? 2 : "";
        
        dispatch(saveEmploymentAnswer(key, answerVal, callback));
     
        
      
    }
  };
  const callback= ()=>{
    setCurrentEmploymentAnswered(true);
    dispatch(getData());
    refreshData();}

  const handleSave = async (key) => {
    if (answer === "") {
      setAnswerError(true);
      return;
    } else {
      let answerVal = "";
      if (key == "empCntr") {
        answerVal = answer;
      } else {
        answerVal = answer === "Yes" ? 1 : answer === "No" ? 2 : "";
      }
      const isGapReason = employment.is_gap_reason;
      if (isGapReason && isGapReason == 1 && answer == "Yes") {
        const caseCheckID = employment.checksDetails[0].case_check_id;
        let checkData = {
          [caseCheckID]: {
            group: "fresher",
          },
        };
        setIsLoading(true);
        const gapReasonResult = await gapReasonApi(checkData, caseCheckID);
        setIsLoading(false);
        if (
          gapReasonResult.data &&
          Object.keys(gapReasonResult.data).length > 0 && gapReasonResult.message!="No gap found."
        ) {
          setGapData(gapReasonResult.data);
          setHasGap(true);
        } else {
          setIsLoading(true);
          dispatch(saveEmploymentAnswer(key, answerVal));
        }
      } else {
        setIsLoading(true);
        dispatch(saveEmploymentAnswer(key, answerVal));
      }
      if (answer === "No") {
        setIsLoading(true);
        await dispatch(getData());
        refreshData();
      }
    }
  };

  const gapReasonApi = async (checkData, caseCheckID) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      setIsLoading(true);

      const requestData = {
        token: userLocalData.id,
        check_data: checkData,
        case_check_id: caseCheckID,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data: result } = await axios.post(
        FOLDERPATH + "/CandidateApi/GapReason",
        requestData,
        {
          headers: headers,
        }
      );
      setIsLoading(false);

      return result;
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      return null;
    }
  };
  const backHandler = () => {
    window.scrollTo(0, 0);
    setShowQuestion(true);
  };

  const handleBackNavigation = () => {
    const userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    navigate(
      `/case-initiation/check-detail/${userLocalData.reference_number}/3`
    );
  };

  const handleEmploymentAddClick = (e) => {
    e.preventDefault();
    handleAddPopup();
  };

  const handleAddPopup = () => {
    setShowAddPopup(true);
  };

  const closeAddPopup = () => {
    setShowAddPopup(false);
  };

  const proceedAdd = async () => {
    setRedirectToTabOne(false);
    await dispatch(addEmployment());
    await dispatch(getData());
    await reRenderAgain(unsavedEmpData, false);
    // setRedirectToTabOne(false);
    setShowAddPopup(false);
    // checkMaximumEmploymentTab();
  };

  const closeGapPopUp = () => {
    setHasGap(false);
  };

  const handleGapReasonSubmit = (gapReasonData) => {
    setIsLoading(true);
    dispatch(saveEmploymentAnswer("fresherValue", 1, gapReasonData));
  };

  const handleUnsavedErrorData = (data) => {
    setUnsavedErrorData(data);
  };
  let empCondition = false;
  if (Object.keys(employmentData).length > 0) {
    const isFresherVal = employmentData?.data?.data?.candidates?.is_fresher;
    const empCheckCountVal =
      employmentData?.data?.data?.candidates?.employment_check_count;
    const fresherEnabledVal = employmentData?.data?.data?.fresher_enabled;
    const empPopupShowVal = employmentData?.data?.data?.employmentpopupshow;
    let showOnlyQuestion = false;
    const bothVal1 =
      fresherEnabledVal === "1" && empPopupShowVal === "1" ? true : false;
    if (fresherEnabledVal == "1" || empPopupShowVal == "1") {
      if (isFresherVal == null) {
        if (bothVal1) {
          showOnlyQuestion = true;
        } else {
          showOnlyQuestion = false;
        }
      } else if (isFresherVal == "1") {
        showOnlyQuestion = true;
      }
    }
    empCondition = showOnlyQuestion ? false : true;
  }

  const checkMaximumEmploymentTab = () => {
    console.log("method called..");
    if (
      employmentAddStore?.employmentAddData &&
      employmentAddStore?.employmentAddData?.message?.toUpperCase() ===
        "MAXIMUM EMPLOYMENTS ALREADY ADDED"
    ) {
      console.log("inside condition called..");
      setShowAlertPopUp(true);
    }
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {hasGap && (
          <EmploymentGaps
            gapData={gapData}
            closeGapPopUp={closeGapPopUp}
            handleGapReasonSubmit={handleGapReasonSubmit}
            gapReasonKey={"eduemp"}
            gapName={"Education to Employment"}
          />
        )}
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Employment"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form
                className="p-3 form2 form-section"
                // style={{ minHeight: "700px" }}
              >
                <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                  <div>
                    <StepCount activeTab={"Employment"} />
                    <h2 className="fnt-smi-bld">Employment</h2>
                    {Object.keys(employment).length > 0 &&
                      employment.employment_config_msg &&
                      employment.employment_config_msg != "" && (
                        <p className="text-muted">
                          {employment.employment_config_msg}
                        </p>
                      )}
                  </div>
                  {Object.keys(employment).length > 0 &&
                    employment.is_custom_employement == 1 &&
                    empCondition == true && (
                      <button
                        className="btn btn-primary add-btn"
                        style={{ minWidth: "155" + "px" }}
                        onClick={(e) => handleEmploymentAddClick(e)}
                      >
                        + Add Employment
                      </button>
                    )}
                </div>
                {isLoading && <Loader />}
                {showCurrentEmploymentQuestion && showCurrentEmploymentQuestion == true && (
                  <QuestionForm
                    isLoading={isLoading}
                    questionName={questionData1.questionKey}
                    questionValue={answer1}
                    question={questionData1.question}
                    handleQuestionChange={handleCurrentEmploymentQuestionChange}
                    questionOptions={questionData1.options}
                    handleSave={handleSave1}
                    answerError={answerError1}
                    setIsLoading={(isLoading) => setIsLoading(isLoading)}
                    handleBackNavigation={handleBackNavigation}
                    answered={currentEmploymentAnswered}
                  />
                )}
                {(showQuestion && (showQuestion == true) && (currentEmploymentAnswered == true || showCurrentEmploymentQuestion == false))&&(
                  <QuestionForm
                    isLoading={isLoading}
                    questionName={questionData.questionKey}
                    questionValue={answer}
                    question={questionData.question}
                    handleQuestionChange={handleQuestionChange}
                    questionOptions={questionData.options}
                    handleSave={handleSave}
                    answerError={answerError}
                    setIsLoading={(isLoading) => setIsLoading(isLoading)}
                    handleBackNavigation={handleBackNavigation}
                    // answered={employmentData?.data?.data?.candidates?.is_fresher}
                    previousAnswer = {employmentData?.data?.data?.candidates?.is_fresher === 1 ? "Yes" : employmentData?.data?.data?.candidates?.is_fresher === 2 ? "No" : ""}
                  />
                )}
                {empCondition && (
                  <MainForm
                    isLoading={isLoading}
                    emp={employment}
                    unsavedErrorData={unsavedErrorData}
                    handleUnsavedErrorData={handleUnsavedErrorData}
                    reRenderAgain={reRenderAgain}
                    refreshData={refreshData}
                    active={activeTab}
                    setIsLoading={(isLoading) => setIsLoading(isLoading)}
                    states={states}
                    currencies={currencies}
                    countryCodeOptions={countryCodeOptions}
                    reference={reference}
                    backHandler={backHandler}
                    showAddPopup={showAddPopup}
                    closeAddPopup={closeAddPopup}
                    proceedAdd={proceedAdd}
                    redirectToTabOne={redirectToTabOne}
                    caseStatusCheckDetails={caseStatusCheckDetails}
                    showAlertPopUp={showAlertPopUp}
                    setShowAlertPopUp={setShowAlertPopUp}
                    previousEmpoymentCountPopUp={previousEmpoymentCountPopUp}
                    setPreviousEmploymentCountPopUp={
                      setPreviousEmploymentCountPopUp
                    }
                  />
                )}
              </form>
              {employment.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}

              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CandidateEmployment;
